/**
 * MoverEtapaDialog — move o lead para outra etapa do pipeline a partir do
 * cockpit (sem drag-and-drop). Carrega as etapas via obterPipeline.
 *
 * Semantica nova do pipeline (2026-06): mover para qualquer etapa e um move
 * direto — NAO coleta mais campos extras (sem motivo de perda, sem aviso de
 * criacao de orcamento). Submete via `onMover(etapaId)`.
 *
 * A etapa atual fica desabilitada, EXCETO a coluna de conversao para um lead
 * parado nela sem ganho (FORM-20): mover para a mesma coluna e o que aplica o
 * ganho no backend — sem a opcao, o conserto nao teria botao.
 */
import React, { useEffect, useState } from "react";

import AsyncButton from "../../../components/AsyncButton";
import SlideOverPanel from "../../../components/SlideOverPanel";
import { useAuth } from "../../../context/AuthContext";
import { obterPipeline } from "../../../services/crm";
import { moverTemEfeito } from "../../../utils/crmPermissoes";
import { Field, FormStack, InlineError, Select } from "../styles";

function rotuloDaEtapa(etapa, lead) {
  if (String(etapa.id) !== String(lead?.etapa)) return etapa.nome;
  return moverTemEfeito(lead?.etapa, etapa, lead)
    ? `${etapa.nome} (atual — confirmar a conversão)`
    : `${etapa.nome} (atual)`;
}

function MoverEtapaDialog({ open, onClose, onMover, lead }) {
  const { request } = useAuth();
  const [etapas, setEtapas] = useState([]);
  const [etapaId, setEtapaId] = useState("");
  const [erro, setErro] = useState(null);

  useEffect(() => {
    if (!open) return;
    setEtapaId("");
    setErro(null);
    obterPipeline(request)
      .then((p) => setEtapas(Array.isArray(p?.etapas) ? p.etapas : []))
      .catch(() => setEtapas([]));
  }, [open, request]);

  const mover = async () => {
    setErro(null);
    if (!etapaId) {
      setErro("Selecione a etapa destino.");
      throw new Error("Etapa obrigatória.");
    }
    await onMover(etapaId);
  };

  return (
    <SlideOverPanel
      open={open}
      onClose={onClose}
      title="Mover etapa"
      subtitle={lead ? `${lead.numero || ""} · ${lead.titulo || ""}` : ""}
      width="min(95vw, 460px)"
      footer={
        <>
          <button type="button" className="btn btn--secondary" onClick={onClose}>
            Cancelar
          </button>
          <AsyncButton
            variant="primary"
            onClick={mover}
            successMessage="Lead movido."
            silentError
          >
            Mover
          </AsyncButton>
        </>
      }
    >
      <FormStack>
        <Field>
          Etapa destino *
          <Select value={etapaId} onChange={(e) => setEtapaId(e.target.value)}>
            <option value="">— Selecione —</option>
            {etapas.map((e) => (
              <option
                key={e.id}
                value={e.id}
                disabled={!moverTemEfeito(lead?.etapa, e, lead)}
              >
                {rotuloDaEtapa(e, lead)}
              </option>
            ))}
          </Select>
        </Field>

        {erro && <InlineError>{erro}</InlineError>}
      </FormStack>
    </SlideOverPanel>
  );
}

export default MoverEtapaDialog;
